import { __assign } from "tslib";
import Vue from 'vue';
import Swiper from 'swiper/dist/js/swiper.min.js';
export default Vue.extend({
    props: {
        slides: {
            type: Array,
            default: function () { return []; }
        },
        currentSlide: {
            type: Number,
            default: 0
        },
        options: {
            type: Object,
            default: null
        },
        pagination: {
            type: Boolean,
            default: true
        },
        navigation: {
            type: Boolean,
            default: true
        },
        vAlign: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            swiper: null,
            emitEvents: [
                'init',
                'update',
                'slideChange',
                'reachBeginning',
                'reachEnd'
            ]
        };
    },
    mounted: function () {
        this.initSwiper();
    },
    destroyed: function () {
        this.swiper.destroy();
    },
    watch: {
        slides: function () {
            var _this = this;
            this.$nextTick(function () {
                _this.swiper.update();
            });
        },
        currentSlide: function (newVal, oldVal) {
            if (this.swiper) {
                if (newVal !== oldVal) {
                    this.swiper.slideTo(newVal, 0);
                }
                else if (newVal === null) {
                    this.swiper.slideTo(0);
                }
            }
        }
    },
    methods: {
        initSwiper: function () {
            var _this = this;
            var defaultOptions = {
                initialSlide: this.currentSlide,
                breakpointsInverse: true,
                watchOverflow: true,
                slidesPerView: 1,
                breakpoints: {
                    768: {
                        slidesPerView: 3
                    }
                },
            };
            if (this.pagination) {
                defaultOptions.pagination = {
                    el: '.swiper-pagination',
                    clickable: true,
                };
            }
            if (this.navigation) {
                defaultOptions.navigation = {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                };
            }
            this.swiper = new Swiper(this.$refs.swiperContainer, __assign(__assign({}, defaultOptions), this.options));
            // Emit selected swiper events to parent
            this.emitEvents.forEach(function (eventKey) {
                _this.swiper.on(eventKey, function () { return _this.$emit(eventKey, _this.swiper); });
            });
        }
    }
});
